import { BindingPath } from "../../Engine/Core/CoreTypes";
import { FullFormState } from "../../Engine/Core/Store/FullFormState";
import { getIn, setIn, updateIn } from "../ReduxStateHelpers";

type HiddenColgroupState = "auto" | "hide" | "show";

interface HiddenColgroupingGroupState {
    state?: HiddenColgroupState;
    filledCount?: number;
}

export function getIsLoading(state: FullFormState, bindingPath: BindingPath): boolean {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return getIn(state, ["tableInfos", bindingPath, "loading"], false);
}

export function setIsLoading(state: FullFormState, bindingPath: BindingPath, loading: boolean): FullFormState {
    return setIn(state, ["tableInfos", bindingPath, "loading"], loading);
}

export function getColumnGroupingGroupStates(
    state: FullFormState,
    bindingPath: BindingPath,
    groupKey?: string
): number | undefined {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return getIn(state, ["tableInfos", bindingPath, "columnGrouping", groupKey ?? "UNDEFINED_GROUP_KEY"], undefined);
}

export function updateColumnGroupingGroupStates(
    state: FullFormState,
    bindingPath: BindingPath,
    groupKey: undefined | string,
    updateFn: (prev: number) => number,
    defaultValue: number
): FullFormState {
    return updateIn(
        state,
        ["tableInfos", bindingPath, "columnGrouping", groupKey ?? "UNDEFINED_GROUP_KEY"],
        updateFn,
        defaultValue
    );
}

export function getHiddenColgroupingGroupStates(
    state: FullFormState,
    bindingPath: BindingPath,
    groupKey: undefined | string
): HiddenColgroupingGroupState {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return getIn(state, ["tableInfos", bindingPath, "hiddenColgrouping", groupKey ?? "UNDEFINED_GROUP_KEY"], {});
}

export function setHiddenColgroupingGroupState(
    state: FullFormState,
    bindingPath: BindingPath,
    groupKey: undefined | string,
    hiddenColgroupState: HiddenColgroupState
): FullFormState {
    return setIn(
        state,
        ["tableInfos", bindingPath, "hiddenColgrouping", groupKey ?? "UNDEFINED_GROUP_KEY", "state"],
        hiddenColgroupState
    );
}

export function updateHiddenColgroupingGroupFilledCount(
    state: FullFormState,
    bindingPath: BindingPath,
    groupKey: undefined | string,
    updateFn: (prev: number) => number,
    defaultValue: number
): FullFormState {
    return updateIn(
        state,
        ["tableInfos", bindingPath, "hiddenColgrouping", groupKey ?? "UNDEFINED_GROUP_KEY", "filledCount"],
        updateFn,
        defaultValue
    );
}
